import { render, staticRenderFns } from "./Windows.vue?vue&type=template&id=5dd4bc70&scoped=true"
import script from "./Windows.vue?vue&type=script&lang=js"
export * from "./Windows.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd4bc70",
  null
  
)

export default component.exports